<template>
  <b-form-group
    label="Servis Durumu"
    label-for="id_service_statuses"
  >
    <validation-provider
      #default="{ errors }"
      name="Servis Durumu"
      rules="required"
    >
      <v-select
        id="id_service_statuses"
        v-model="dataItem.id_service_statuses"
        :options="serviceStatuses"
        label="title"
        :reduce="item => item.id"
        placeholder="Seçiniz"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'ServiceStatuses',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['services/dataItem']
    },
    serviceStatuses() {
      return this.$store.getters['serviceStatuses/dataList']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('serviceStatuses/getDataList', {
        select: [
          'service_statuses.id AS id',
          'service_statuses.title AS title',
        ],
      })
    },
  },
}
</script>
